/**
 * T-05 (conversion audit) — Microsoft Clarity session replay.
 *
 * Loads only when the server exposes a project id
 * (/api/settings/public-config clarityProjectId) AND the signed-in user
 * is not an admin — admin sessions are the owner's own noise, and
 * skipping them is how "exclude Admin routes" is enforced (only admins
 * can reach #admin). Anonymous visitors (signup/login screens) ARE
 * recorded — those sessions are the point of the ticket.
 *
 * Privacy: Clarity's default Balanced masking hides all typed input
 * text (passwords/emails never appear in replays); the owner should
 * additionally set the project to Strict masking in the Clarity
 * dashboard before sharing replays outside the team.
 */

const ADMIN_ROLES = ['admin', 'angel_admin', 'god_admin'];
let _loaded = false;

export function initClarity(projectId, user) {
    if (_loaded || !projectId) return;
    if (user && ADMIN_ROLES.includes(user.role)) return;
    if (!/^[a-z0-9]{4,20}$/i.test(String(projectId))) return;
    _loaded = true;
    /* Official Clarity snippet, unrolled */
    window.clarity = window.clarity || function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.clarity.ms/tag/' + projectId;
    document.head.appendChild(s);
}
